/**
 * Colour theme (issue #27).
 *
 * With no saved choice the page follows the operating system through
 * `prefers-color-scheme`, entirely in CSS. A saved choice is written to
 * `<html data-theme>`, which overrides the media query. index.html applies the saved
 * choice in an inline script before first paint, so a forced theme never flashes the
 * other one; that script reads the same storage key as this module.
 */
export type ThemePreference = 'system' | 'light' | 'dark'

export const THEME_STORAGE_KEY = 'flightdeck.theme'

export function storedTheme(): ThemePreference {
  try {
    const value = localStorage.getItem(THEME_STORAGE_KEY)
    return value === 'light' || value === 'dark' ? value : 'system'
  } catch {
    // Storage can be blocked (private windows, site-data settings); follow the system.
    return 'system'
  }
}

export function applyTheme(preference: ThemePreference): void {
  const root = document.documentElement
  if (preference === 'system') delete root.dataset.theme
  else root.dataset.theme = preference
  try {
    if (preference === 'system') localStorage.removeItem(THEME_STORAGE_KEY)
    else localStorage.setItem(THEME_STORAGE_KEY, preference)
  } catch {
    // Not persisted, but still applied for this page view.
  }
}
